import i from './checkout-tnc-dialog.container';

export default i;
